<template>
	<v-container class="member-loan-overview" fluid>
		<v-card class="pa-3 elevation-1" :color="bg" outlined>
			<div class="d-flex justify-space-between align-center mb-3">
				<div class="font-weight-medium">وام هایی که ضامن {{ area === 'member' ? 'هستم' : 'شده اند' }}</div>
				<v-chip v-if="items.length" color="primary" text-color="white" small pill>
					{{ items.length }} وام
				</v-chip>
			</div>

			<v-skeleton-loader v-if="loading" type="list-item@3" class="mt-1" />
			<div v-if="!items.length && !loading" class="grey--text text-center pa-3">
				وامی یافت نشد.
			</div>
			<v-card class="pa-2 rounded-xl" outlined elevation="0" v-for="thirdPersonAssuranceAuthorizationItem in items" :key="thirdPersonAssuranceAuthorizationItem.id">
				<div>
					<div class="text-body-1 font-weight-bold secondary--text">
						{{ memberName(thirdPersonAssuranceAuthorizationItem) }}
					</div>
					<div class="grey--text ">
						<small> کد ملی: {{ nationalCode(thirdPersonAssuranceAuthorizationItem) }}</small>
					</div>
					<div class="d-flex flex-wrap align-center">
						<div class="info-pill">
							<span class="grey--text text--darken-1">تاریخ درخواست: </span>
							<span class="font-weight-medium">{{ requestDate(thirdPersonAssuranceAuthorizationItem)
							}}</span>
						</div>
						<div class="info-pill">
							<span class="grey--text text--darken-1">مبلغ وام: </span>
							<span class="font-weight-medium">{{ amount(thirdPersonAssuranceAuthorizationItem) }}
								<small>تومان</small></span>
						</div>
						<div class="info-pill">
							<span class="grey--text text--darken-1">قسط: </span>
							<span class="font-weight-medium">
								{{ installment(thirdPersonAssuranceAuthorizationItem) }}
								<small>تومان</small>
							</span>
						</div>
					</div>
					<div class="mt-2 text-justify" style="font-size: 13px;" v-if="thirdPersonAssuranceAuthorizationItem.tag" v-html="thirdPersonAssuranceAuthorizationItem.tag">

					</div>
					<div class="d-flex justify-center mt-2">
						<v-btn small outlined color="secondary" style="min-width: 100px;" @click="showContract(thirdPersonAssuranceAuthorizationItem)">
							{{
								thirdPersonAssuranceAuthorizationItem.isSigned
									? 'مشاهده قرارداد' : 'مشاهده و امضا قرارداد'
							}}
						</v-btn>
					</div>

				</div>
			</v-card>
		</v-card>

		<v-dialog v-model="contractDialog" max-width="1600px">
			<v-card color="#eee">
				<v-card-title>
					<div>
						<span class="headline">اطلاعات قرارداد</span>
					</div>
					<v-spacer />
					<v-btn @click="contractDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<ContractDetail v-if="contractDialog" area="member" role="guarantor" :auth="selectedThirdPersonAssuranceAuthorizationItem.userLoanRequestAuthorizationItem" :thirdPersonAssuranceAuthorizationItem="selectedThirdPersonAssuranceAuthorizationItem" :mobile="selectedThirdPersonAssuranceAuthorizationItem.user?.mobile" @updated="loadData" />
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import api from '@/util/app-api'
import { get } from 'vuex-pathify'
import toast from '@/util/toast'
import { cloneDeep } from 'lodash'

export default {
	name: 'ThirdPersonAssurancesWidget',
	props: {
		bg: { type: String, default: 'white' },
		area: { type: String, default: 'member' },
		memberId: { type: Number },
	},
	data() {
		return {
			loading: true,
			selectedThirdPersonAssuranceAuthorizationItem: null,
			contractDialog: false,
			items: [],
		}
	},
	components: {
		ContractDetail: () => import('@/components/loanAuthorizations/ContractDetail'),
	},
	computed: {

	},
	mounted() {
		this.loadData()
	},
	methods: {
		loadData() {
			this.loading = true
			api.get(`${this.area}/ThirdPersonAssuranceAuthorizationItem/GetAssurancedItems/${this.area === 'member' ? '' : this.memberId}`, null)
				.then(response => {
					this.items = response
				})
				.catch(err => {
					toast.error('خطا در دریافت لیست وام هایی که ضامن هستید.' + err.message)
				})
				.finally(() => this.loading = false)
		},
		showContract(data) {
			this.selectedThirdPersonAssuranceAuthorizationItem = data
			this.contractDialog = true
		},
		memberName(item) {
			return item.userLoanRequestAuthorizationItem?.userLoanRequest?.memberModel?.fullName || item.userLoan?.memberModel?.fullName || 'نامشخص'
		},
		nationalCode(item) {
			return item.userLoanRequestAuthorizationItem?.userLoanRequest?.memberModel?.nationalCode || item.userLoan?.memberModel?.nationalCode || 'نامشخص'
		},
		requestDate(item) {
			return item.userLoanRequestAuthorizationItem?.userLoanRequest?.requestDate_Persian?.date || item.userLoan?.startDate_Persian?.date || 'نامشخص'
		},
		amount(item) {
			let price = item.userLoanRequestAuthorizationItem?.userLoanRequest?.amount || item.userLoan?.amount || 0
			return String(price).toPriceFormat()
		},
		installment(item) {
			let installment = item.userLoanRequestAuthorizationItem?.userLoanRequest?.installment || item.userLoan?.installment || 0
			return String(installment).toPriceFormat()
		}
	}
}
</script>
<style scoped>
.contract b {
	font-weight: 900;
	border-bottom: 1px dotted blue;
	color: blue;
}
</style>
